export default "__VITE_ASSET__4263fc27__"